import { render, staticRenderFns } from "./DetailedPointsBalance.vue?vue&type=template&id=10b6a6f8&scoped=true&"
import script from "./DetailedPointsBalance.vue?vue&type=script&lang=ts&"
export * from "./DetailedPointsBalance.vue?vue&type=script&lang=ts&"
import style0 from "./DetailedPointsBalance.vue?vue&type=style&index=0&id=10b6a6f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b6a6f8",
  null
  
)

export default component.exports